<!-- 日次締め -> 売掛金 -> レジ締め済取引の払戻・修正 / 過去営業日取引の追加 || Get new set of data and display only, will not update by others -->
<template>
  <el-table
    :data="blendData"
    :span-method="spanMethod"
    :row-class-name="rowClassName"
    class="egl-table past-business-day-transactions-table"
    stripe
    border
  >
    <el-table-column
      prop="type"
      :label="$locale('dailyClosing.theaterAdvanceTicketTable.theaterPastBusinessDayTransactionsTable.th.ticketType')"
      width="140"
      align="center"
    >
      <template slot-scope="scope">
        <div v-if="scope.row.rowType !== 'total'" :class="[scope.row.rowType === 'subtotal' ? 'sub-total-row' : '' ]">
          {{ accountsReceivableType[scope.row.type] }}
        </div>
        <div v-else>{{ scope.row.type }}</div>
      </template>
    </el-table-column>

    <el-table-column
      prop="name"
      :label="$locale('dailyClosing.theaterAdvanceTicketTable.theaterPastBusinessDayTransactionsTable.th.accountReceivableName')"
      width="180"
      align="center"
    >
      <template slot-scope="scope">
        {{ scope.row.name }}
      </template>
    </el-table-column>

    <el-table-column
      prop="qty"
      :label="$locale('dailyClosing.theaterAdvanceTicketTable.theaterPastBusinessDayTransactionsTable.th.qty')"
      align="center"
    >
      <template slot-scope="scope">
        <div class="ta-r">{{ scope.row.qty | separatorFormatter }}</div>
      </template>
    </el-table-column>

    <el-table-column
      prop="actualQty"
      :label="$locale('dailyClosing.theaterAdvanceTicketTable.theaterPastBusinessDayTransactionsTable.th.actualQty')"
      align="center"
    >
      <template slot-scope="scope">
        <div class="ta-r">{{ scope.row.actualQty | separatorFormatter }}</div>
      </template>
    </el-table-column>

    <el-table-column
      prop="cashQty"
      :label="$locale('dailyClosing.theaterAdvanceTicketTable.theaterPastBusinessDayTransactionsTable.th.cashQty')"
      align="center"
    >
      <template slot-scope="scope">
        <div class="ta-r">{{ scope.row.cashQty | separatorFormatter }}</div>
      </template>
    </el-table-column>

    <el-table-column
      prop="dayActualQty"
      :label="$locale('dailyClosing.theaterAdvanceTicketTable.theaterPastBusinessDayTransactionsTable.th.dayActualQty')"
      align="center"
    >
      <template slot-scope="scope">
        <div class="ta-r">{{ scope.row.dayActualQty | separatorFormatter }}</div>
      </template>
    </el-table-column>

    <el-table-column
      prop="amount"
      :label="$locale('dailyClosing.theaterAdvanceTicketTable.theaterPastBusinessDayTransactionsTable.th.amount')"
      align="center"
    >
      <template slot-scope="scope">
        <div class="ta-r">{{ scope.row.amount | currencyFormatter }}</div>
      </template>
    </el-table-column>

    <el-table-column
      prop="actualAmount"
      :label="$locale('dailyClosing.theaterAdvanceTicketTable.theaterPastBusinessDayTransactionsTable.th.actualAmount')"
      align="center"
    >
      <template slot-scope="scope">
        <div class="ta-r">{{ scope.row.actualAmount | currencyFormatter }}</div>
      </template>
    </el-table-column>

    <el-table-column
      prop="cashBalance"
      :label="$locale('dailyClosing.theaterAdvanceTicketTable.theaterPastBusinessDayTransactionsTable.th.cashBalance')"
      align="center"
    >
      <template slot-scope="scope">
        <div class="ta-r">{{ scope.row.cashBalance | currencyFormatter }}</div>
      </template>
    </el-table-column>

    <el-table-column
      prop="actualSales"
      :label="$locale('dailyClosing.theaterAdvanceTicketTable.theaterPastBusinessDayTransactionsTable.th.actualSales')"
      align="center"
    >
      <template slot-scope="scope">
        <div class="ta-r">{{ scope.row.actualSales | currencyFormatter }}</div>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import tranfResData from "@/utils/tranfResData";
import { ticketDetailResStruct } from "@/assets/js/dailyClosingNew";

export default {
  name: "PastBizDayTrans",
  props: {
    accountsReceivableType: {
      type: Object,
      default: () => ({}),
    },
    tableData: {
      type: Object,
      default: () => ({
        couponType: [],
        nationalTicket: [],
        settlement: [],
      }),
    },
    actionType: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  computed: {
    blendData() {
      const _totalBase = ticketDetailResStruct();
      _totalBase.type = this.$locale("global.total");
      _totalBase.rowType = "total";

      const _tableData = tranfResData(this.tableData);
      let resultArray = [];

      const _addPropFn = (objArray, type) => {
        const _subTotalBase = ticketDetailResStruct();

        objArray.forEach((_item, i) => {
          // let __price = this.receivableListMappingFn(type, _item.settlementId).price || 0;
          // __price = __price !== 0 ? __price : rounding(_item.amount / _item.qty);
          // _item.price = __price;
          _item.type = type;
          _item.index = i;

          if (i === 0) {
            _item.rowspan = objArray.length + 1;
            _item.colspan = 1;
          } else {
            _item.rowspan = 0;
            _item.colspan = 0;
          }

          for (let __key in _subTotalBase) {
            if (typeof _item[__key] === "number") {
              _subTotalBase[__key] += _item[__key];
              _totalBase[__key] += _item[__key];
            } else if (__key === "name") {
              _subTotalBase[__key] = this.accountsReceivableType[_item.type] + " " + this.$locale("global.total");
            }
          }
        });

        objArray.push({
          ..._subTotalBase,
          rowType: "subtotal",
          type,
        });

        return objArray;
      };

      Object.keys(_tableData).forEach(_key => {
        if (_tableData[_key].length > 0) {
          const _subList = _addPropFn(_tableData[_key], _key);
          resultArray.push(..._subList);
        }
      });

      resultArray.push(_totalBase);

      return resultArray;
    },
  },
  methods: {
    spanMethod({ row, columnIndex }) {
      if (row.rowType === "total") {
        if (columnIndex === 0) {
          return [1, 2];

        } else if (columnIndex < 2) {
          return [0, 0];
        }
      }

      if (columnIndex === 0) {
        const { rowspan, colspan } = row;
        return [rowspan, colspan];
      }
    },
    rowClassName({ row }) {
      if (row.rowType === "subtotal") {
        return "sub-total-row";
      } else if (row.rowType === "total") {
        return "total-row";
      }
      return "";
    },
  },
};

</script>